import { render, staticRenderFns } from "./TotalIncome.vue?vue&type=template&id=0b0de3f0&scoped=true&"
import script from "./TotalIncome.vue?vue&type=script&lang=js&"
export * from "./TotalIncome.vue?vue&type=script&lang=js&"
import style0 from "./TotalIncome.vue?vue&type=style&index=0&id=0b0de3f0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b0de3f0",
  null
  
)

export default component.exports